<template>
  <section class="workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header">
        <div>
          <span class="workspace-kicker">Promociones</span>
          <h2 class="workspace-title">Links promocionales</h2>
          <p class="workspace-copy">Convierte tus codigos en links listos para compartir en campañas, embajadores y mensajes directos.</p>
        </div>
      </div>

      <div v-if="loading && !codes.length" class="workspace-empty">Cargando links promocionales...</div>
      <div v-else-if="!codes.length" class="workspace-empty">Aun no hay codigos activos. Crea uno en Codigos para generar links promocionales.</div>
      <div v-else class="workspace-table-shell">
        <table class="workspace-table">
          <thead>
            <tr>
              <th>Codigo</th>
              <th>Etiqueta</th>
              <th>Status</th>
              <th>Link</th>
              <th>Accion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="eventCode in codes" :key="eventCode.id">
              <td>{{ eventCode.code }}</td>
              <td>{{ eventCode.label || 'Sin etiqueta' }}</td>
              <td>
                <span :class="['workspace-status-pill', eventCode.is_active ? 'is-active' : 'is-off']">
                  {{ eventCode.is_active ? 'Activo' : 'Archivado' }}
                </span>
              </td>
              <td>
                <a class="workspace-inline-link" :href="fullPromoUrl(eventCode.code)" target="_blank">Abrir link</a>
              </td>
              <td>
                <button class="workspace-button workspace-button--small" type="button" @click="copyPromoLink(eventCode.code)">
                  <i class="fas fa-copy"></i>
                  <span>Copiar</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p v-if="successMessage" class="workspace-feedback workspace-feedback--success">{{ successMessage }}</p>
    </article>
  </section>
</template>

<script>
import { apiService } from '../../common/api.services.js'

export default {
  name: 'PromoTable',

  props: {
    event: {
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      codes: [],
      successMessage: '',
    }
  },

  created() {
    this.getCodes()
  },

  watch: {
    event: {
      deep: true,
      handler() {
        this.getCodes()
      },
    },
  },

  methods: {
    getCodes() {
      if (!this.event || !this.event.id) {
        return
      }

      this.loading = true
      apiService(`/api/host/events/${this.event.id}/codes/`).then((data) => {
        this.codes = Array.isArray(data) ? data.filter((code) => code.is_active) : []
      }).finally(() => {
        this.loading = false
      })
    },

    fullPromoUrl(code) {
      return `${window.location.origin}/event/${this.event.slug}?co=${encodeURIComponent(code)}&wanted=true`
    },

    copyPromoLink(code) {
      navigator.clipboard.writeText(this.fullPromoUrl(code)).then(() => {
        this.successMessage = `Link de ${code} copiado.`
      })
    },
  },
}
</script>

<style scoped>
.workspace-table-shell {
  overflow: auto;
}

.workspace-table {
  width: 100%;
  border-collapse: collapse;
}

.workspace-table th,
.workspace-table td {
  padding: 14px 12px;
  border-bottom: 1px solid rgba(223, 214, 255, 0.08);
  text-align: left;
  color: var(--text-soft);
}

.workspace-table th {
  color: var(--text-main);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.workspace-inline-link {
  color: #cbffe8;
}
</style>
